//userdetails.jsx

const initialState = JSON.parse(localStorage.getItem("user")) || {
  id: null,
  first_name: "",
  last_name: "",
  date_created: "",
  last_login: "",
  email: "",
  role: "",
  avatar: "",
  theme: localStorage.getItem("theme") || "light"
};

export function ToogleTheme(){

  return {
  type : "TOOGLE_THEME",
  }
    
}

export function setUserDetails(details={}){
    return {
    type : "SET_USER_DETAILS",
    payload : {
      ...details
    }
    }
}
export function getUserDetails(){
    return {
    type : "GET_USER_DETAILS",
    payload : {
      ...JSON.parse(localStorage.getItem("user"))
    }}
}

export function resetUserDetails(){
    return {
    type : "RESET_USER_DETAILS"
    }
}

function userReducer(currentUser = initialState, action){
  switch(action.type){
    case "SET_USER_DETAILS":
      return {
        ...currentUser,
        ...action.payload
      }
    case "GET_USER_DETAILS":
      return {
        ...currentUser,
        ...action.payload
      }
    case "RESET_USER_DETAILS":
      return {
      }
    case "TOOGLE_THEME":
      const newTheme = localStorage.getItem("theme") === "light" ? "dark" : "light"
      return {
        ...currentUser,
        theme : newTheme
      }

    default:

      return currentUser

  }
}

export default userReducer